import React from "react";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

function NoEmployee({ licenseCount }: any) {
    return (
        <div className="box-description mav-risk-not-found null-body-detected-breach">
            <div className="row row-container">
                <div className="col-sm-3"></div>

                <div className="col-xs-12 col-sm-12 text-align-center col-main">
                    <RenderIcons iconName="info-circle" />
                    <div>
                        <div className="title-main mtb-1rem">{`0 of ${licenseCount} Employees Added`}</div>
                        <div className="description">To begin adding your employees, you can upload a file with their information or add them individually.</div>
                    </div>
                </div>

                <div className="col-sm-3"></div>
            </div>
        </div>
    );
}

export default NoEmployee;
